import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../../config/env';

export const productApi = createApi({
  reducerPath: 'productApiSlice',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.auth?.token;
      headers.set('Authorization', `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ['Products'],
  endpoints: (builder) => ({
    getProducts: builder.query({
      query: ({ search, clientId } = {}) => ({
        url: 'product',
        params: {
          ...(search && { search }),
          ...(clientId && { client_id: clientId }),
        },
      }),
      providesTags: ['Products'],
      refetchOnMountOrArgChange: false,
      keepUnusedDataFor: 60,
    }),

    addNewProduct: builder.mutation({
      query: (formData) => ({
        url: 'product',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Products'],
    }),

    deleteProduct: builder.mutation({
      query: (productId) => ({
        url: `product/delete/${productId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Products'],
    }),

    updateProduct: builder.mutation({
      query: ({ productId, data }) => ({
        url: `product/edit/${productId}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['Products'],
    }),
  }),
});

export const {
  useGetProductsQuery,
  useAddNewProductMutation,
  useDeleteProductMutation,
  useUpdateProductMutation,
} = productApi;
